import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import DetectType from 'enums/DetectType'

// eslint-disable-next-line import/prefer-default-export
export const fromViewOption = (viewOption?: InsightViewOptionStrings) => {
  switch (viewOption) {
    case InsightViewOption.LOGOS:
      return DetectType.LOGO
    case InsightViewOption.DETECT_OBJECTS:
      return DetectType.OBJECT
    case InsightViewOption.DETECT_SCENES:
      return DetectType.SCENE
    case InsightViewOption.DETECT_EMOTIONS:
      return DetectType.EMOTION
    default:
      throw new Error(`No mapping specified with viewOption: ${viewOption}`)
  }
}
